export enum AnswerCategoryType {
    None = 0,
    SatisfactionRateNegative = 1,
    SatisfactionRateNegativeDescription = 'Negative',
    SatisfactionRateNeutral = 2,
    SatisfactionRateNeutralDescription = 'Neutral',
    SatisfactionRatePositive = 3,
    SatisfactionRatePositiveDescription = 'Positive'
}